"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var resources = tslib_1.__importStar(require("../../resources"));
var modelMap = require('./model-relationships').default;
function requireResourceByModelName(name) {
    var requireData = modelMap[name];
    if ('object' !== typeof requireData) {
        throw new Error('Invalid model name');
    }
    return resources[requireData.resourceClassName];
}
exports.requireResourceByModelName = requireResourceByModelName;
//# sourceMappingURL=resolve.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/util/resources/resolve.js
// module id = 1RM+
// module chunks = 0